import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  user: {},
  isCollapse: false,
  tableHeaderColor: '#eef0f4',
  userType: {
    1: '学生',
    2: '研究生',
    3: '教职工'
  },
  source: {
    1: '高职',
    2: '附中'
  },
  roles: [],
  stuStatus: [
    {label: '到', key: '3', type: 'green', name: '已到', alias: null},
    {label: '旷', key: '0', type: 'danger', name: '旷课'},
    {label: '迟', key: '2', type: 'warning', name: '迟到'},
    {label: '退', key: '4', type: 'lightblue', name: '早退'},
    {label: '假', key: '1', type: 'blue', name: '请假'},
    {label: '公', key: '5', type: 'blue', name: '公假'}
  ],
  updateMode: {
    0: '签到码',
    1: '手动点名'
  },
  courseStudentStatus: {
    0: {title: '正常', type: 'primart'},
    1: {title: '免听', type: 'success'},
    2: {title: '休学', type: 'warning'},
    3: {title: '退学', type: 'info'}
  }
};

const mutations = {};

Object.keys(state).forEach(k => {
  mutations[k] = (state, data) => {
    state[k] = data;
  };
});

export default new Vuex.Store({
  state,
  mutations
});
